import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import {
  Card,
  Col,
  Row,
  Typography,
  Input,
  Button,
  Form,
  Select,
  Space,
  Modal,
} from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { useAppSelector } from "store";
import React, { useState } from "react";
import { useMasterBoxes } from "hooks/useMasterData";
import { GetAllMasterBoxesRequest } from "services/interface";
import SettingBoxList from "./SettingBoxList";
import ModalAdd from "./ModalAdd";

const SettingBox = () => {
  const navigate = useNavigate();

  const contact = useAppSelector((state) => state.auth.contact);

  const [limit, setLimit] = useState<number>(10);
  const [offset, setOffset] = useState<number>(0);
  const [searchParams, setSearchParams] = useState<GetAllMasterBoxesRequest>({
    page_number: 1,
    row_per_page: 10,
  });
  const [form] = Form.useForm();
  const [searchModalVisible, setSearchModalVisible] = useState(false);

  const { data, refetch } = useMasterBoxes(searchParams);
  
  console.log('🏠 [SettingBox Component] searchParams:', searchParams);
  console.log('🏠 [SettingBox Component] data:', data);

  const handleSearch = () => {
    console.log('🔍 [SettingBox Component] handleSearch called');
    const formValues = form.getFieldsValue();
    setSearchParams(prev => ({
      ...prev,
      search: formValues.search || "",
      name: formValues.name || "",
      min_width: formValues.width || undefined,
      max_width: formValues.width || undefined,
      min_length: formValues.length || undefined,
      max_length: formValues.length || undefined,
      min_height: formValues.height || undefined,
      max_height: formValues.height || undefined,
      is_active: formValues.is_active !== undefined && formValues.is_active !== '' ? formValues.is_active : undefined, // ✅ แก้ไข: ตรวจสอบทั้ง undefined และ empty string
      sort_options: formValues.sort_field && formValues.sort_order ? 
        [{ field: formValues.sort_field, order: formValues.sort_order }] : 
        prev.sort_options,
      page_number: 1,
      row_per_page: limit,
    }));
    setOffset(0);
    setSearchModalVisible(false);
  };


  const handleClearSearch = () => {
    form.resetFields();
    setSearchParams(prev => ({
      ...prev,
      search: "",
      name: "",
      min_width: undefined,
      max_width: undefined,
      min_length: undefined,
      max_length: undefined,
      min_height: undefined,
      max_height: undefined,
      is_active: undefined,
      sort_options: [],
      page_number: 1,
      row_per_page: limit,
    }));
    setOffset(0);
    setSearchModalVisible(false);
  };

  const sortOptions = [
    { label: 'ชื่อ', value: 'name' },
    { label: 'ความกว้าง', value: 'width' },
    { label: 'ความยาว', value: 'length' },
    { label: 'ความสูง', value: 'height' },
    { label: 'น้ำหนัก', value: 'weight' },
    { label: 'วันที่สร้าง', value: 'create_date' },
  ];

  const sortOrderOptions = [
    { label: 'น้อยไปมาก', value: 'ASC' },
    { label: 'มากไปน้อย', value: 'DESC' },
  ];

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/setting");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>ตั้งค่ากล่อง</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <>
              <TitleWrapper>
                {/* Desktop Layout */}
                <div className="desktop-layout" style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 16,
                  width: "100%",
                  padding: 10,
                  justifyContent: "flex-end",
                }}>
                  {/* Action Buttons */}
                  <div style={{ display: "flex", gap: 8 }}>
                    <Button 
                      type="primary" 
                      onClick={() => setSearchModalVisible(true)}
                      icon={<SearchOutlined />}
                      style={{ backgroundColor: '#FFD700', borderColor: '#FFD700', color: '#000000' }}
                    >
                      ค้นหา
                    </Button>
                    <ModalAdd />
                  </div>
                </div>

                {/* Mobile Layout */}
                <div className="mobile-layout" style={{
                  display: "none",
                  flexDirection: "row",
                  gap: 8,
                  width: "100%",
                  padding: 10,
                  justifyContent: "flex-end",
                }}>
                  <Button 
                    type="primary" 
                    onClick={() => setSearchModalVisible(true)}
                    icon={<SearchOutlined />}
                    style={{ backgroundColor: '#FFD700', borderColor: '#FFD700', color: '#000000' }}
                  >
                    ค้นหา
                  </Button>
                  <ModalAdd />
                </div>
              </TitleWrapper>

              <SettingBoxList
                data={data}
                refetch={refetch}
                limit={limit}
                offset={offset}
                setLimit={setLimit}
                setOffset={setOffset}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                onSearch={handleSearch}
              />

              {/* Search Modal */}
              <Modal
                title="ค้นหาข้อมูลกล่อง"
                open={searchModalVisible}
                onCancel={() => setSearchModalVisible(false)}
                footer={[
                  <Button key="cancel" onClick={() => setSearchModalVisible(false)}>
                    ยกเลิก
                  </Button>,
                  <Button key="clear" onClick={handleClearSearch}>
                    ล้างการค้นหา
                  </Button>,
                  <Button key="search" type="primary" onClick={handleSearch} style={{ backgroundColor: '#FFD700', borderColor: '#FFD700', color: '#000000' }}>
                    ค้นหา
                  </Button>,
                ]}
                width={600}
              >
                <Form form={form} layout="vertical">
                  {/* ชื่อกล่อง + สถานะ */}
                  <Row gutter={16}>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="ชื่อกล่อง" name="name">
                        <Input 
                          placeholder="กรอกชื่อกล่อง" 
                          maxLength={100}
                          showCount
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="สถานะ" name="is_active">
                        <Select placeholder="เลือกสถานะ" options={[
                          { label: 'แสดงทั้งหมด', value: '' }, // ✅ เพิ่มตัวเลือก "แสดงทั้งหมด" เป็นตัวเลือกแรก
                          { label: 'เปิดใช้งาน', value: true },
                          { label: 'ปิดใช้งาน', value: false }
                        ]} />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* กว้าง, ยาว, สูง */}
                  <Row gutter={16}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="กว้าง (ซ.ม.)" name="width">
                        <Input placeholder="กรอกความกว้าง" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="ยาว (ซ.ม.)" name="length">
                        <Input placeholder="กรอกความยาว" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="สูง (ซ.ม.)" name="height">
                        <Input placeholder="กรอกความสูง" />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* เรียงลำดับ + รูปแบบการเรียงลำดับ */}
                  <Row gutter={16}>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="เรียงลำดับจาก" name="sort_field">
                        <Select placeholder="เลือกฟิลด์เรียงลำดับ" options={sortOptions} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="รูปแบบการเรียงลำดับ" name="sort_order">
                        <Select placeholder="เลือกรูปแบบ" options={sortOrderOptions} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Modal>
            </>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SettingBox;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #efefef;

  @media (max-width: 768px) {
    .desktop-layout {
      display: none !important;
    }
    
    .mobile-layout {
      display: flex !important;
    }
  }

  @media (min-width: 769px) {
    .desktop-layout {
      display: flex !important;
    }
    
    .mobile-layout {
      display: none !important;
    }
  }
`;
